// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__QoCTx","imageUploader":"EGiftCard_imageUploader__RAHx8"};